import { Switch } from '@mantine/core';

import { useEucdmCodes } from '@hooks/useEucdmCodes';

interface EucdmToggleProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  label?: string;
}

export const EucdmToggle: React.FC<EucdmToggleProps> = ({ size = 'sm', label = 'Show EUCDM Codes' }) => {
  const { showEucdmNumbers, toggleEucdmDisplay } = useEucdmCodes();

  return (
    <Switch
      checked={showEucdmNumbers}
      onChange={toggleEucdmDisplay}
      size={size}
      label={label}
      styles={{
        label: {
          fontWeight: 600,
          fontSize: '14px',
        },
      }}
    />
  );
};
